<ng-template
  #formular
  let-data
  >
  <div class="formular-card">
    <div class="formular-header mb-4">
      <div class="formular-icon">
        <i class="ri-key-fill"></i>
      </div>
      <div>
        <div
          class="formular-title"
          i18n="@@search-key-value-title"
        >Suchschlüssel und Wert</div>
        <div
          class="formular-subtitle"
          i18n="@@search-key-value-subtitle"
          >
          Definiere den Suchschlüssel und den dazugehörigen Wert, nach dem gesucht werden soll.
        </div>
      </div>
    </div>

    <div class="row align-items-start gx-3">
      <div class="col-lg-5">
        <label
          class="form-label fw-semibold"
          i18n="@@search-key"
        >Suchschlüssel</label>
        <input
          pInputText
          [(ngModel)]="data.key"
          (ngModelChange)="formularModelChange()"
          [ngModelOptions]="{updateOn: 'blur'}"
          class="w-100"
          >
      </div>

      <div
        class="col-auto d-flex align-items-center"
        style="margin-top: 2rem;"
        >
        <p-button
          severity="secondary"
          [rounded]="true"
          [text]="false"
          size="small"
          [disabled]="true"
          icon="ri ri-arrow-right-s-line"
        ></p-button>
      </div>

      <div class="col">
        <label
          class="form-label fw-semibold"
          i18n="@@value"
        >Wert</label>
        <textarea
          pInputTextarea
          [(ngModel)]="data.value"
          (ngModelChange)="formularModelChange()"
          [ngModelOptions]="{updateOn: 'blur'}"
          class="w-100"
          rows="3"
        ></textarea>
      </div>
    </div>

    <div class="d-flex gap-2 mt-4">
      @if (this.getSelectedItemState() === 'new') {
        <p-button
          severity="primary"
          size="small"
          (onClick)="this.addItemToList();"
          >
          <i class="ri-add-fill"></i>
          <span i18n="@@add">Hinzufügen</span>
        </p-button>
      }
      @if (this.getSelectedItemState() === 'new') {
        <p-button
          severity="secondary"
          size="small"
          (onClick)="this.paramForNewForm = undefined"
          >
          <span i18n="@@cancel">Abbrechen</span>
        </p-button>
      }
    </div>
  </div>
</ng-template>

<ng-template
  #preconditionForm
  let-data
  >
  <div>
    <p-button
      type="button"
      size="small"
      severity="secondary"
      [disabled]="possibleTrunkItemsForConditionSelection(data).length === 0"
      (click)="openPreconditionMenu($event, preconditionMenu, data)"
      >
      @if (data.conditions.length === 0) {
        <ng-container i18n="@@always-active-title">immer aktiv:</ng-container>
      }
      @if (data.conditions.length > 0) {
        <ng-container i18n="@@active-when-title">aktiv wenn:</ng-container>
      }
      <i class="ri-mind-map"></i>
      <i class="ri-arrow-down-s-line"></i>
    </p-button>
    <p-menu
      #preconditionMenu
      [popup]="true"
      appendTo="body"
      [baseZIndex]="9000"
      [model]="preconditionMenuItems"
    ></p-menu>
  </div>

  @for (conditionEntry of data.conditions; track $index) {
    <div class="row gx-0">
      <div class="col-auto pe-3">
        <i
          class="ri-close-circle-fill cursor-pointer text-danger"
          (click)="this.removeCondition(data, conditionEntry.trunkItemId)"
        ></i>
      </div>

      <div class="col">
        {{ this.getTrunkItemById(conditionEntry.trunkItemId)!.key }}

        <p-button
          type="button"
          size="small"
          severity="secondary"
          variant="outlined"
          [rounded]="true"
          (click)="openConditionTypeMenu($event, conditionTypeMenu, data, conditionEntry)"
          >
          {{ this.conditionTypeToName(conditionEntry.condition) }}
        </p-button>

        <p-menu
          #conditionTypeMenu
          [popup]="true"
          appendTo="body"
          [baseZIndex]="9000"
          [model]="conditionTypeMenuItems"
        ></p-menu>
      </div>
    </div>
  }
</ng-template>
@if (this.rss.datatrunk) {
  <div class="row align-items-baseline">
    <div class="col">
      <h3
        class="mt-4"
        i18n="@@edit-database"
        >
        Datenbank Bearbeiten
      </h3>
    </div>
    <div class="col-auto text-end">
      <app-skill-id-input
        [value]="this.rss.datatrunk.skillId"
        (changed)="this.rss.datatrunk.skillId = $event; this.updateDatabase(this.rss.datatrunk)"
      ></app-skill-id-input>
    </div>
    <div class="col-auto text-end pe-0">
      <p-toggleswitch
        [(ngModel)]="this.rss.datatrunk.active"
        (ngModelChange)="this.updateDatabase(this.rss.datatrunk)"
      ></p-toggleswitch>
    </div>
  </div>
  <p-divider
    align="left"
    styleClass="mt-4 mb-1"
  >
    <span
      class="text-muted small fw-semibold"
      i18n="@@ki-recognition"
    >KI-Erkennung</span>
  </p-divider>
  <div class="row  mt-3">
    <div class="col-3">
      <span i18n="@@intended-database-use">
        Verwendungszweck der Datenbank
      </span>
      <app-hint i18n="@@intended-database-use-hint">Beschreibe der KI, wofür diese Datenbank genutzt werden soll. Das
        hilft dem Bot zu entscheiden, wann er in dieser Datenbank sucht.</app-hint>
    </div>
    <div class="col">
      <p-inputgroup>
        <p-inputgroup-addon>
          <i
            class="ri-sparkling-fill text-primary"
            style="font-size: 1.2rem;"
          ></i>
        </p-inputgroup-addon>
        <input
          pInputText
          placeholder=""
          [(ngModel)]="this.rss.datatrunk.trunkDescription"
          (ngModelChange)="this.updateDatabase(this.rss.datatrunk)"
          [ngModelOptions]="{updateOn: 'blur'}"
          >
      </p-inputgroup>
      <span i18n="@@example-database-use">
        Beispiele: <b>Nachschlagewerk für Fachbegriffe</b>, <b>detaillierte Informationen zu einem Produkt</b>, oder
        <b>die häufigsten Fragen und Antworten.</b>
      </span>
    </div>
  </div>
  <div class="row align-items-center mt-3 ">
    <div class="col-3">
      <span i18n="@@functionname">Funktionsname</span>
      <app-hint i18n="@@function-name-hint">
        Bitte wähle für deinen Skill einen sprechenden bzw. aussagekräftigen (Funktions)-Namen.
        Es sind max. <b>30 Zeichen</b> für einen Namen zulässig, sowie ausschließlich folgende Zeichen:
        <b>a-z</b>, <b>A-Z</b>, <b>0-9</b>, <b>-</b> und <b>_</b>.
      </app-hint>
    </div>
    <div class="col">
      <app-function-name-suggest
        [descriptionString]="this.rss.datatrunk.trunkDescription"
        (finish)="this.rss.datatrunk.placeholder = $event; this.onPlaceholderChange($event)"
        style="display: block; width: 100%;"
      >
        <input
          pInputText
          type="text"
          maxlength="30"
          [(ngModel)]="this.rss.datatrunk.placeholder"
          [ngModelOptions]="{updateOn: 'blur'}"
          (ngModelChange)="this.rss.checkFunctionName(this.rss.datatrunk.placeholder) && this.onPlaceholderChange(this.rss.datatrunk.placeholder)"
          fluid
        />
      </app-function-name-suggest>
    </div>
  </div>
  <h5
    class="mt-5"
    i18n="@@database-entries"
  >Datenbankeinträge</h5>
  <div [@.disabled]="true">
    <p-message severity="secondary">
      <span i18n="@@database-entries-description">
        Mit <b>Suchschlüsseln</b> gibst du dem Bot an, nach welcher Art von Einträgen dieser in der Datenbank suchen
        kann.
      </span>
    </p-message>
  </div>
  <div class="row  mt-4">
    <div class="col-3">
      <span i18n="@@search-key-meaning">
        Bedeutung des Suchschlüssels
      </span>
    </div>
    <div class="col">
      <p-inputgroup>
        <p-inputgroup-addon>
          <i
            class="ri-sparkling-fill text-primary"
            style="font-size: 1.2rem;"
          ></i>
        </p-inputgroup-addon>
        <input
          pInputText
          placeholder=""
          [(ngModel)]="this.rss.datatrunk.keyDescription"
          (ngModelChange)="this.updateDatabase(this.rss.datatrunk)"
          [ngModelOptions]="{updateOn: 'blur'}"
          fluid
          >
      </p-inputgroup>
      <span i18n="@@search-key-meaning-example">
        Beispiele: <b>der gesuchte Fachbegriff</b>, <b>die Produktbezeichnung</b>, oder <b>die Fragestellung.</b>
      </span>
    </div>
  </div>
  <div class="row mt-5">
    @if (this.paramForNewForm) {
      <div class="col-12">
        <ng-template
          [ngTemplateOutlet]="formular"
          [ngTemplateOutletContext]="{ $implicit: this.paramForNewForm }"
          >
        </ng-template>
      </div>
    }
    @if (!this.paramForNewForm && this.mode !== 'import') {
      <div
        class="d-flex align-items-center justify-content-between col-12 mb-2"
        >
        <p-button
          severity="primary"
          size="small"
          (onClick)="this.selectEmptyParam()"
          >
          <i class="ri-add-fill"></i>
          <span i18n="@@new-entry">Neuer Eintrag</span>
        </p-button>
        <div>
          <rag-excel-import
            [config]="this.xlsxConfig"
            [class]="'p-button p-button-sm p-button-outlined p-button-secondary'"
            [demoFileName]="'demo-import'"
            [demoData]="[{key: 'test', value: 'tset'}]"
            [importButton]="this.importButton"
            [downloadButton]="this.downloadButton"
            (import)="this.onExcelInput($event)"
            >
          </rag-excel-import>
          <rag-excel-export
            [class]="'p-button p-button-sm p-button-outlined p-button-secondary ms-1'"
            [config]="this.xlsxConfig"
            [fileName]="'export_'+this.rss.datatrunk!.placeholder"
            [data]="this.rss.datatrunk.items"
            [exportButton]="this.exportButton"
            >
          </rag-excel-export>
        </div>
      </div>
    }
  </div>
  @if (this.mode === 'import') {
    <div class="row align-items-center mt-5">
      <div class="col">
        <h3 i18n="@@import">Import</h3>
      </div>
      <div class="col-auto text-end">
        <p-button
          severity="secondary"
          (onClick)="this.mode = 'edit'"
          i18n="@@cancel"
        >Abbrechen</p-button>
        @if (this.importedDataList.length > 0) {
          <p-button
            severity="primary"
            size="small"
            (onClick)="this.importGuestList()"
            [disabled]="this.importing"
            >
            @if (importing) {
              <span
                class="spinner-border spinner-border-sm"
                aria-hidden="true"
                >
              </span>
            }
            @if (!importing) {
              <span><i class="ri-import-fill"></i></span>
            }
            <span
              role="status"
              i18n="@@import-data"
              >
          Daten importieren
        </span>
          </p-button>
        }
      </div>
    </div>
    <p-table
      [value]="this.importedDataList"
      styleClass="p-datatable-sm"
      >
      <ng-template pTemplate="header">
        <tr>
          <th i18n="@@search-key">Suchschlüssel</th>
          <th i18n="@@value">Wert</th>
          <th style="width: 4rem;"></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-item
        >
        <tr>
          <td>
            <input
              pInputText
              [(ngModel)]="item.key"
              fluid
              >
          </td>
          <td>
            <input
              pInputText
              [(ngModel)]="item.value"
              fluid
              >
          </td>
          <td style="width: 4rem; text-align: center; vertical-align: middle;">
            <p-button
              severity="danger"
              size="small"
              (onClick)="this.removeImportedDatabaseItem(item)"
              >
              <ng-template pTemplate="content">
                <i class="ri-close-line"></i>
              </ng-template>
            </p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
  @if (this.rss.datatrunk.items.length > 0) {
    <p-table
      [value]="this.rss.datatrunk.items"
      styleClass="db-items-table mt-3"
      >
      <ng-template pTemplate="header">
        <tr>
          <th i18n="@@search-key-italic"><i class="ri-key-fill me-1"></i>Suchschlüssel</th>
          <th i18n="@@value-italic"><i class="ri-file-text-line me-1"></i>Wert</th>
          <th i18n="@@rating"><i class="ri-star-line me-1"></i>Bewertung</th>
          <th i18n="@@status">Status</th>
          <th
            class="text-end"
            i18n="@@actions"
          ></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-item
        let-rowIndex="rowIndex"
        >
        <tr>
          @if (this.selectedItem !== item) {
            <td class="align-middle col-key">
              <span class="key-chip">
                <i class="ri-key-fill"></i>
                <span>{{ item.key }}</span>
              </span>
            </td>
            <td class="align-middle text-muted col-value">
              <i class="ri-file-text-line me-1"></i>{{ item.value }}
            </td>
            <td
              class="align-middle"
              style="min-width: 260px;"
              >
              @if (this.enumTestResult.has(item.key)) {
                <div
                  class="bewertung-card"
                  [@.disabled]="true"
                  >
                  <span class="bewertung-badge">{{ this.enumTestResult.get(item.key)?.bewertung }}</span>
                  <span class="bewertung-text">{{ this.enumTestResult.get(item.key)?.grund }}</span>
                </div>
              }
            </td>
            <td class="align-middle">
              <ng-template
                [ngTemplateOutlet]="preconditionForm"
                [ngTemplateOutletContext]="{ $implicit: item }"
              ></ng-template>
            </td>
            <td class="text-end align-middle">
              <p-menu
                #menu
                appendTo="body"
                [baseZIndex]="9000"
                [model]="dataBaseDetailContextMenu"
                [popup]="true"
              ></p-menu>
              <p-button
                (onClick)="openDatabaseDetailMenu($event, menu, rowIndex)"
                severity="secondary"
                [raised]="true"
                [text]="true"
                [rounded]="true"
                icon="ri ri-more-2-fill"
              ></p-button>
            </td>
          }
          @if (this.selectedItem === item) {
            <td
              colspan="5"
              class="p-4"
              >
              <ng-template
                [ngTemplateOutlet]="formular"
                [ngTemplateOutletContext]="{ $implicit: item }"
              ></ng-template>
              <div class="mt-3">
                <ng-template
                  [ngTemplateOutlet]="preconditionForm"
                  [ngTemplateOutletContext]="{ $implicit: item }"
                ></ng-template>
              </div>
              <div class="mt-3">
                <p-button
                  severity="primary"
                  size="small"
                  (onClick)="this.selectedItemIndex = -1"
                  label="Speichern"
                  i18n-label="@@save"
                ></p-button>
                <p-button
                  severity="secondary"
                  size="small"
                  (onClick)="this.selectedItemIndex = -1"
                  class="ms-2"
                  i18n="@@cancel"
                  >Abbrechen</p-button>
                </div>
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
      <div>
        <div class="row mt-3">
          <p-inputgroup>
            <input
              #enumTestString
              pInputText
              [attr.disabled]="this.enumTestIsRunning?'disabled':null"
              fluid
              p-size="small"
              >
            <p-button
              severity="primary"
              size="small"
              (onClick)="this.enumTest(enumTestString.value)"
              [attr.disabled]="this.enumTestIsRunning?'disabled':null"
              i18n="@@test-search-key"
              >
                       Suchschlüssel testen
        </p-button>
            </p-inputgroup>
          </div>
        </div>
      }
    }